export enum ChecklistTypeEnum {
  yesNo = 'Ja/Nee',
  goodBad = 'Goed/Slecht'
}
